import { useEffect, useState } from 'react'

const isDocumentVisible = () => document.visibilityState !== 'hidden'

const useDocumentVisibility = () => {
  const [isVisible, setIsVisible] = useState(isDocumentVisible)

  useEffect(() => {
    const handleVisibilityChange = () => setIsVisible(isDocumentVisible())

    document.addEventListener('visibilitychange', handleVisibilityChange)
    return () =>
      document.removeEventListener('visibilitychange', handleVisibilityChange)
  }, [])

  return isVisible
}

export default useDocumentVisibility
